import styled from "styled-components";
const Toolbar = styled("div")(
  {
    display: "flex",
    gap: 8,
    minWidth: 0,
    overflow: "hidden"
  },
  ({ inline }) => inline ? {
    padding: 4,
    margin: "-4px -12px"
  } : {
    padding: 8
  },
  ({ justify }) => justify === "end" ? {
    justifyContent: "flex-end"
  } : {
    justifyContent: "space-between"
  }
);
export {
  Toolbar
};
